import { render, staticRenderFns } from "./chengxinghetong.vue?vue&type=template&id=be757bfc&scoped=true&"
import script from "./chengxinghetong.vue?vue&type=script&lang=js&"
export * from "./chengxinghetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be757bfc",
  null
  
)

export default component.exports